import type { SubjectTypesFetchedAction } from '@Application/SubjectTypes/Actions/subjectTypesFetched';
import type { SubjectTypeArchivedAction } from '@Application/SubjectTypeDefinitions/Actions/subjectTypeArchived';
import type { SubjectTypeDefinitionSavedAction } from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionSaved';
import type { SubjectTypeRestoredAction } from '@Application/SubjectTypeDefinitions/Actions/subjectTypeRestored';
import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import SubjectTypeView from '@UI/Store/SubjectTypes/Views/SubjectTypeView';
import SubjectTypesListView from '@UI/Store/SubjectTypes/Views/SubjectTypesListView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type SubjectTypesStore = {
	types: SubjectTypesListView | null;
};

const initialState: SubjectTypesStore = {
	types: null,
};

type Actions =
	| SubjectTypesFetchedAction
	| SubjectTypeDefinitionSavedAction
	| SubjectTypeArchivedAction
	| SubjectTypeRestoredAction
	| UserRevokedAction;

const whenSubjectTypesFetched = (
	_store: SubjectTypesStore,
	action: SubjectTypesFetchedAction,
): SubjectTypesStore => ({
	types: new SubjectTypesListView(
		action.payload.accountId,
		action.payload.types.map((type) => new SubjectTypeView(type)),
	),
});

// The administration changed what the menu lists: dropping the cache makes `useSubjectTypes` re-fetch.
const whenDefinitionsChanged = (): SubjectTypesStore => initialState;

const whenUserRevoked = (): SubjectTypesStore => initialState;

export default registerStore<'subjectTypesStore', Actions>(
	'subjectTypesStore',
	createSliceReducer({
		SUBJECT_TYPES_FETCHED: whenSubjectTypesFetched,
		SUBJECT_TYPE_DEFINITION_SAVED: whenDefinitionsChanged,
		SUBJECT_TYPE_ARCHIVED: whenDefinitionsChanged,
		SUBJECT_TYPE_RESTORED: whenDefinitionsChanged,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
